import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { AndroidPermissions } from '@ionic-native/android-permissions';
import { ModalController, Platform } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '@shared/providers/utils.service';

declare const Html5Qrcode: any;

@Component({
  selector: 'app-qr-code-reader',
  templateUrl: './qr-code-reader.component.html',
  styleUrls: ['./qr-code-reader.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QrCodeReaderComponent implements OnInit, OnDestroy {
  private html5Qrcode: any;

  constructor(
    public modalController: ModalController,
    private utils: UtilsService,
    private platform: Platform,
    private translate: TranslateService
  ) {}

  async ngOnInit(): Promise<void> {
    if (this.platform.is('android')) {
      // Utilizando o método de verificação de permissões do utilsService
      await this.utils.verifyPermissions(
        AndroidPermissions.PERMISSION.CAMERA,
        'COMPONENTS.MODALS.NEED_PERMISSION_CAMERA'
      );
    }

    Html5Qrcode.getCameras()
      .then((devices: string | any[]) => {
        if (devices?.length) {
          const qrCodeSuccessCallback = (qrcode: string) => {
            this.html5Qrcode
              .stop()
              .then(() => {
                this.onQrCodeDetect(qrcode);
              })
              .catch(err => {
                this.utils.showToast('Erro ao parar leitor', err, 5000);
              });
          };
          const qrCodeSize = { width: 250, height: 250 }; // Tamanho do leitor QrCode
          const fps = 10; // Quantidade de frames por segundo
          const config = { fps: fps, qrbox: qrCodeSize };
          const backCamera = { facingMode: 'environment' };

          this.html5Qrcode = new Html5Qrcode('reader');
          this.html5Qrcode.start(backCamera, config, qrCodeSuccessCallback);
        }
      })
      .catch(err => {
        this.utils.showToast(
          this.translate.instant('COMPONENTS.MODALS.CHECK_PERMISSION_CAMERA_TO_CONTINUE'),
          err,
          4000
        );
      });
  }

  ngOnDestroy(): void {
    if (this.html5Qrcode) {
      this.html5Qrcode.stop();
    }
  }

  async onQrCodeDetect(event: string): Promise<void> {
    if (event) {
      await this.modalController.dismiss(event);
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
